import { useNavigate } from "react-router-dom";
import heroImage from "../../assets/budget-grey 1.png";
import "./Home.css";
function Hero() {
  const navigate = useNavigate();

  const isLoggedIn = localStorage.getItem("jwt_token") !== null;
  return (
    <div>
      {/* Hero Section */}
      <section className="hero-section">
        <h2 className="hero-subtitle">
          Explore Sri Lanka authentically with local guides, trusted stays, and
          seamless bookings
        </h2>
        <h1 className="hero-title">All in one platform.</h1>
        <p className="hero-description">
          Soloway is a travel platform that connects travelers with local
          guides, hotel owners, and essential services like visa assistance and
          travel insurance all in one easy-to-use system.
        </p>
        {!isLoggedIn && (
          <button className="btn-primary" onClick={() => navigate("/login")}>
            <span className="btn-text">Get Started Free</span>
            <span className="btn-arrow">
              <span>→</span>
            </span>
          </button>
        )}

        <div className="hero-image-container">
          <img src={heroImage} alt="Traveler" className="hero-image" />
        </div>
      </section>
    </div>
  );
}

export default Hero;
